module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/location-e9dcd656717e004e4d3286e02293da42.svg&quot;;"